import { action, makeAutoObservable, observable } from "mobx";
var AppInfoStore = /** @class */ (function () {
    function AppInfoStore() {
        Object.defineProperty(this, "IEContactID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "ApiVersion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "Copyright", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "country", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "regions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "states", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "marketType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "userInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        makeAutoObservable(this, {
            country: observable,
            regions: observable,
            marketType: observable,
            IEContactID: observable,
            states: observable,
            userInfo: observable,
            setAppInfo: action,
            setMarketType: action,
            setRegions: action,
            setCountry: action,
            setStates: action,
            storeUserInfo: action
        });
    }
    Object.defineProperty(AppInfoStore.prototype, "setMarketType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (values) {
            this.marketType = values;
        }
    });
    Object.defineProperty(AppInfoStore.prototype, "setRegions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (values) {
            this.regions = values;
        }
    });
    Object.defineProperty(AppInfoStore.prototype, "setCountry", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (values) {
            this.country = values;
        }
    });
    Object.defineProperty(AppInfoStore.prototype, "setStates", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (values) {
            this.states = values;
        }
    });
    Object.defineProperty(AppInfoStore.prototype, "storeUserInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.userInfo = value;
        }
    });
    Object.defineProperty(AppInfoStore.prototype, "setAppInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id, apiVersion, Copyright) {
            this.IEContactID = id;
            this.ApiVersion = apiVersion;
            this.Copyright = Copyright;
        }
    });
    Object.defineProperty(AppInfoStore.prototype, "getAppINfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return ({
                IEContactID: this.IEContactID,
                apiVersion: this.ApiVersion,
                Copyright: this.Copyright,
            });
        }
    });
    return AppInfoStore;
}());
export default AppInfoStore;
